module.exports = __webpack_public_path__ + "media/customizations/rendezvous/back-78a7ffad44cedec481692ea5303f0ece.jpg";